import { defineComponent, ref, computed, openBlock, createElementBlock, Fragment, createElementVNode, mergeProps, renderSlot, createBlock, Teleport, normalizeStyle, unref, normalizeClass, toDisplayString } from "vue";
import { offset, flip, shift, arrow, useFloating, autoUpdate } from "@floating-ui/vue";
const _hoisted_1 = ["data-placement"];
const _hoisted_2 = ["textContent"];
const _sfc_main = /* @__PURE__ */ defineComponent({
  ...{ inheritAttrs: false },
  __name: "Tooltip",
  props: {
    content: { default: "" },
    position: { default: "top" },
    effect: { default: "dark" },
    trigger: { default: "hover" },
    showAfter: { default: 0 },
    closeAfter: { default: 150 },
    maxWidth: { default: 300 },
    disabled: { type: Boolean, default: false }
  },
  setup(__props) {
    const props = __props;
    let showTimer;
    let hideTimer;
    const isVisible = ref(false);
    const reference = ref(null);
    const floating = ref(null);
    const floatingArrow = ref(null);
    const handleMouseEnter = () => {
      if (props.disabled) return;
      clearTimeout(hideTimer);
      if (props.trigger === "hover") {
        showTimer = setTimeout(() => {
          isVisible.value = true;
        }, props.showAfter);
      }
    };
    const handleMouseLeave = () => {
      clearTimeout(showTimer);
      hideTimer = setTimeout(() => {
        isVisible.value = false;
      }, props.closeAfter);
    };
    const handleClick = () => {
      if (props.disabled) return;
      if (props.trigger === "click") {
        isVisible.value = !isVisible.value;
      }
    };
    const arrowLength = computed(() => {
      if (!floatingArrow.value) return 0;
      return floatingArrow.value.offsetWidth;
    });
    const floatingOffset = computed(() => {
      return Math.sqrt(2 * arrowLength.value ** 2) / 2;
    });
    const position = computed(() => {
      return props.position;
    });
    const middleware = computed(() => {
      return [offset(floatingOffset.value), flip(), shift(), arrow({ element: floatingArrow })];
    });
    const staticSide = computed(() => {
      const side = placement.value.split("-")[0];
      if (!side) return "top";
      return {
        top: "bottom",
        right: "left",
        bottom: "top",
        left: "right"
      }[side];
    });
    const arrowLightPositionStyle = computed(() => {
      if (props.effect !== "light") return {};
      const side = placement.value.split("-")[0];
      if (!side) return {};
      switch (side) {
        case "right":
          return {
            borderTop: "none",
            borderRight: "none"
          };
        case "left":
          return {
            borderBottom: "none",
            borderLeft: "none"
          };
        case "top":
          return {
            borderTop: "none",
            borderLeft: "none"
          };
        case "bottom":
          return {
            borderBottom: "none",
            borderRight: "none"
          };
        default:
          return {};
      }
    });
    const arrowClasses = computed(() => {
      return ["tooltip__arrow", `tooltip__arrow--${props.effect}`];
    });
    const tooltipClasses = computed(() => {
      return ["tooltip", `tooltip--${props.effect}`];
    });
    const { floatingStyles, middlewareData, placement } = useFloating(reference, floating, {
      placement: position,
      strategy: "fixed",
      middleware,
      whileElementsMounted: autoUpdate
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock(Fragment, null, [
        createElementVNode("div", mergeProps({
          ref_key: "reference",
          ref: reference,
          class: "reference"
        }, _ctx.$attrs, {
          onMouseenter: handleMouseEnter,
          onMouseleave: handleMouseLeave,
          onClick: handleClick
        }), [
          renderSlot(_ctx.$slots, "default", {}, void 0, true)
        ], 16),
        (openBlock(), createBlock(Teleport, { to: "body" }, [
          createElementVNode("div", {
            ref_key: "floating",
            ref: floating,
            class: normalizeClass(unref(tooltipClasses)),
            style: normalizeStyle([
              unref(floatingStyles),
              {
                opacity: unref(isVisible) ? 1 : 0,
                pointerEvents: unref(isVisible) ? "auto" : "none",
                transition: "opacity 0.15s ease"
              }
            ]),
            onMouseenter: handleMouseEnter,
            onMouseleave: handleMouseLeave
          }, [
            createElementVNode("div", {
              class: "tooltip__bridge",
              "data-placement": unref(placement)
            }, null, 8, _hoisted_1),
            createElementVNode("div", {
              class: "max-w-[300px] text-left",
              style: normalizeStyle({
                maxWidth: typeof +__props.maxWidth === "number" ? `${__props.maxWidth}px` : __props.maxWidth
              })
            }, [
              createElementVNode("span", {
                textContent: toDisplayString(__props.content)
              }, null, 8, _hoisted_2)
            ], 4),
            createElementVNode("div", {
              ref_key: "floatingArrow",
              ref: floatingArrow,
              class: normalizeClass(unref(arrowClasses)),
              style: normalizeStyle([
                {
                  position: "absolute",
                  left: unref(middlewareData).arrow?.x != null ? `${unref(middlewareData).arrow.x}px` : "",
                  top: unref(middlewareData).arrow?.y != null ? `${unref(middlewareData).arrow.y}px` : "",
                  bottom: "",
                  right: "",
                  [unref(staticSide)]: `${-unref(arrowLength) / 2}px`
                },
                unref(arrowLightPositionStyle)
              ])
            }, null, 6)
          ], 38)
        ]))
      ], 64);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=Tooltip.vue2.js.map
